import React, { useEffect, useState } from "react";
import { InputNumber, Alert, Form, Button, Card } from "antd";
import "./exam.css";

const ExamOTP = (props) => {
  const onFinish = (values) => {
    
    props.formSubmitHandler(values);
  };
  return (
    <React.Fragment>
      <Card
        title={
          <h3 style={{ margin: 0, color: "#fff", fontWeight: 600 }}>
            Please Enter Your OTP
          </h3>
        }
        bordered={false}
        style={{
          width: "600px",
          margin: "10% auto",
          backgroundColor: "#424358",
          fontWeight: 600,
        }}
      >
        {props.errroMsg ? (
          <Alert message={props.errroMsg} type="error" />
        ) : null}
        <Form
          name="otp"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          layout="horizontal"
          colon={false}
          size="large"
          onFinish={onFinish}
        >
          <Form.Item
            label="Your OTP"
            name="OTP"
            rules={[{ required: true, message: "Please input your otp!" }]}
          >
            <InputNumber />
          </Form.Item>

          <Form.Item>
            <div
              style={{ textAlign: "center", width: "550px", marginTop: "20px" }}
            >
              <Button
                type="primary"
                htmlType="submit"
                style={{ fontWeight: 600 }}
              >
                Submit
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Card>
    </React.Fragment>
  );
};
export default ExamOTP;
